// src/components/ChatPanel.jsx
import React, { useEffect, useRef } from 'react';
import { MessageBody } from './MessageBody';

export function ChatPanel({ messages }) {
  const containerRef = useRef(null);

  // Scroll automatique en bas
  useEffect(() => {
    const c = containerRef.current;
    if (c) c.scrollTop = c.scrollHeight;
  }, [messages]);

  return (
    <div ref={containerRef} className="chat-panel">
      {messages.map((m, i) => (
        <div key={i} className="game-message">
          <div className="speaker-emoji" aria-hidden>
            🗣️
          </div>
          <div className="bubble">
            {/* Texte + media (image / gif Tenor / audio) via le rendu partage.
                autoPlayAudio: seul le dernier message revele joue automatiquement. */}
            <MessageBody content={m.content} autoPlayAudio={i === messages.length - 1} />
          </div>
        </div>
      ))}
    </div>
  );
}
